import type { HeadingTokens } from './types';

export const heading: HeadingTokens = {
  letterSpacings: {
    1: 'condensed',
    2: null,
    3: null,
    4: null,
    5: null,
    6: null,
  },
};
